import React from 'react';
import { motion } from 'framer-motion';

interface Props {
  tab: string;
  children: React.ReactNode;
}

export function TabTransition({ tab, children }: Props) {
  return (
    <motion.div
      key={tab}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.2 }}
    >
      {children}
    </motion.div>
  );
}
